<template lang="">
  <div>
    <b-row>
      <b-col cols="6">
        <b-select
          v-model="answer.kind"
          @change="handleChange"
          :disabled="Object.keys(answer.answers).length > 0"
        >
          <b-form-select-option :value="null"
            >Selecciona un Evalúa estandarización 4</b-form-select-option
          >
          <b-form-select-option
            v-for="(test, index) in tests"
            :key="index"
            :value="index"
            >Evalua 4 nivel {{ index }}</b-form-select-option
          >
        </b-select>
      </b-col>
      <b-col>
        <b-button pill variant="primary" @click="clearAnswer(answer.kind)">
          Limpiar y cambiar el nivel de evalua
        </b-button>
      </b-col>
    </b-row>
    <!-- Instrucción añadida aquí -->
    <p v-if="answer.kind != null"><strong>Ingresa los puntajes tipificados (PT)</strong></p>
    <GenericTest
      v-if="answer.kind != null"
      :test="tests[answer.kind]"
      :test_id="test_id"
      :answer="answer"
      :semester="semester"
      :previous_answer="previous_answer"
    ></GenericTest>
  </div>
</template>
<script>
import GenericTest from "./GenericTest";
export default {
  components: { GenericTest },
  props: ["test_id", "student_id", "previous_answer", "semester"],
  watch: {
    student_id() {
      this.answer.student_id = this.student_id;
    },
    test_id() {
      this.answer.test = this.test_id;
    },
    oldEvaluation() {
      if (this.oldEvaluation >= 0) {
        this.answer.kind = this.oldEvaluation;
      }
    },
  },
  computed: {
    required: function () {
      return this.tests[this.answer.kind]
        .filter((elem) => elem.var != null)
        .map((elem) => elem.var);
    },
    oldEvaluation() {
      if (Object.keys(this.previous_answer).length) {
        let firstVal = parseInt(Object.keys(this.previous_answer)[0]);
        if (
          (firstVal >= 0 && firstVal < 12) ||
          (firstVal >= 176 && firstVal < 180)
        )
          return 0;
        else if (
          (firstVal >= 12 && firstVal < 27) ||
          (firstVal >= 180 && firstVal < 184)
        ) {
          return 1;
        } else if (
          (firstVal >= 27 && firstVal < 42) ||
          (firstVal >= 184 && firstVal < 188)
        ) {
          return 2;
        } else if (
          (firstVal >= 42 && firstVal < 57) ||
          (firstVal >= 188 && firstVal < 192)
        ) {
          return 3;
        } else if (
          (firstVal >= 57 && firstVal < 74) ||
          (firstVal >= 192 && firstVal < 196)
        ) {
          return 4;
        } else if (
          (firstVal >= 74 && firstVal < 91) ||
          (firstVal >= 196 && firstVal < 200)
        ) {
          return 5;
        } else if (
          (firstVal >= 91 && firstVal < 108) ||
          (firstVal >= 200 && firstVal < 204)
        ) {
          return 6;
        } else if (
          (firstVal >= 108 && firstVal < 126) ||
          (firstVal >= 204 && firstVal < 208)
        ) {
          return 7;
        } else if (
          (firstVal >= 126 && firstVal < 143) ||
          (firstVal >= 208 && firstVal < 212)
        ) {
          return 8;
        } else if (
          (firstVal >= 143 && firstVal < 160) ||
          (firstVal >= 212 && firstVal < 216)
        ) {
          return 9;
        } else if (
          (firstVal >= 160 && firstVal < 176) ||
          (firstVal >= 216 && firstVal < 220)
        ) {
          return 10;
        }
      }
      return -1;
    },
  },
  created() {
    if (this.oldEvaluation >= 0) {
      this.answer.kind = this.oldEvaluation;
    }
  },
  methods: {
    handleChange(value) {
      this.clearAnswer(value);
      // console.log(value);
    },
    clearAnswer(value) {
      this.answer = {
        test: this.test_id,
        answers: {},
        student_id: this.student_id,
        kind: value,
      };
    },
  },
  data() {
    return {
      answer: {
        test: this.test_id,
        answers: {},
        student_id: this.student_id,
        kind: null,
      },
      tests: [
        [
          {
            type: "h3",
            label: "Prueba de Seriaci\u00f3n (SE)",
          },
          {
            label: "Puntaje (PT)",
            var: "1",
            type: "number",
          },
          {
            type: "h3",
            label: "Organizacion perceptiva (OP)",
          },
          {
            label: "Puntaje (PT)",
            var: "2",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de Clasificaci\u00f3n (CA)",
          },
          {
            label: "Puntaje (PT)",
            var: "0",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de Memoria verbal (MV)",
          },
          {
            label: "Puntaje (PT)",
            var: "3",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de Sonidos y letras (SL)",
          },
          {
            label: "Puntaje (PT)",
            var: "8",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de Comprensi\u00f3n oral (CO)",
          },
          {
            label: "Puntaje (PT)",
            var: "4",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de Recepcion auditiva y articulacion (RA)",
          },
          {
            label: "Puntaje (PT)",
            var: "5",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de Habilidades Fonologicas (HF)",
          },
          {
            label: "Puntaje (PT)",
            var: "6",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de Velocidad de Nombrado (VN)",
          },
          {
            label: "Puntaje (PT)",
            var: "7",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de Copia de dibujos (CD)",
          },
          {
            label: "Puntaje (PT)",
            var: "9",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de Grafomotricidad (GM)",
          },
          {
            label: "Puntaje (PT)",
            var: "10",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de N\u00fameros y Cantidad (NC)",
          },
          {
            label: "Puntaje (PT)",
            var: "11",
            type: "number",
          },
          { type: "h3", label: "Prueba de Índice cognitivo (IGC)" },
          { label: "Puntaje (PT)", var: "176", type: "number" },
          { type: "h3", label: "Prueba de Índice lectura (IGL)" },
          { label: "Puntaje (PT)", var: "177", type: "number" },
          { type: "h3", label: "Prueba de Índice escritura (IGE)" },
          { label: "Puntaje (PT)", var: "178", type: "number" },
          { type: "h3", label: "Prueba de Índice matemáticas (IGM)" },
          { label: "Puntaje (PT)", var: "179", type: "number" },
        ],
        [
          {
            type: "h3",
            label: "Prueba de Seriaci\u00f3n (SE)",
          },
          {
            label: "Puntaje (PT)",
            var: "13",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de Organizaci\u00f3n perceptiva (OP)",
          },
          {
            label: "Puntaje (PT)",
            var: "15",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de Clasificaci\u00f3n (CA)",
          },
          {
            label: "Puntaje (PT)",
            var: "14",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de Memoria y Atenci\u00f3n (MA)",
          },
          {
            label: "Puntaje (PT)",
            var: "12",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de Comprension lectora (CL)",
          },
          {
            label: "Puntaje (PT)",
            var: "17",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de Exactitud lectora (EL)",
          },
          {
            label: "Puntaje (PT)",
            var: "16",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de Ortograf\u00eda Visual (OR)",
          },
          {
            label: "Puntaje (PT)",
            var: "19",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de Expresi\u00f3n escrita (GR)",
          },
          {
            label: "Puntaje (PT)",
            var: "20",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de Ortografia fon\u00e9tica (OF)",
          },
          {
            label: "Puntaje (PT)",
            var: "18",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de C\u00e1lculo y numeraci\u00f3n (CN)",
          },
          {
            label: "Puntaje (PT)",
            var: "21",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de Resoluci\u00f3n de problemas (RP)",
          },
          {
            label: "Puntaje (PT)",
            var: "22",
            type: "number",
          },
          {
            type: "h3",
            label: "Motivaci\u00f3n escolar",
          },
          {
            label: "Puntaje (PT)",
            var: "23",
            type: "number",
          },
          {
            type: "h3",
            label: "Autocontrol y autonomia",
          },
          {
            label: "Puntaje (PT)",
            var: "24",
            type: "number",
          },
          {
            type: "h3",
            label: "Conductas pro sociales",
          },
          {
            label: "Puntaje (PT)",
            var: "25",
            type: "number",
          },
          {
            type: "h3",
            label: "Autoconcepto y autoestima",
          },
          {
            label: "Puntaje (PT)",
            var: "26",
            type: "number",
          },
          { type: "h3", label: "Prueba de Índice cognitivo (IGC)" },
          { label: "Puntaje (PT)", var: "180", type: "number" },
          { type: "h3", label: "Prueba de Índice lectura (IGL)" },
          { label: "Puntaje (PT)", var: "181", type: "number" },
          { type: "h3", label: "Prueba de Índice escritura (IGE)" },
          { label: "Puntaje (PT)", var: "182", type: "number" },
          { type: "h3", label: "Prueba de Índice matemáticas (IGM)" },
          { label: "Puntaje (PT)", var: "183", type: "number" },
        ],
        [
          {
            type: "h3",
            label: "Prueba de Reflexividad (RE)",
          },
          {
            label: "Puntaje (PT)",
            var: "30",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de Analog\u00edas (PA)",
          },
          {
            label: "Puntaje (PT)",
            var: "28",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de Organizaci\u00f3n perceptiva (OP)",
          },
          {
            label: "Puntaje (PT)",
            var: "29",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de Memoria y atenci\u00f3n (MA)",
          },
          {
            label: "Puntaje (PT)",
            var: "27",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de Comprension lectora (CL)",
          },
          {
            label: "Puntaje (PT)",
            var: "31",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de Exactitud lectora (EL)",
          },
          {
            label: "Puntaje (PT)",
            var: "32",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de Ortografia visual (OR)",
          },
          {
            label: "Puntaje (PT)",
            var: "34",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de Expresi\u00f3n escrita (GR)",
          },
          {
            label: "Puntaje (PT)",
            var: "35",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de Ortografia fon\u00e9tica (OF)",
          },
          {
            label: "Puntaje (PT)",
            var: "33",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de C\u00e1lculo y numeraci\u00f3n (CN)",
          },
          {
            label: "Puntaje (PT)",
            var: "36",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de Resoluci\u00f3n de problemas (RP)",
          },
          {
            label: "Puntaje (PT)",
            var: "37",
            type: "number",
          },
          {
            type: "h3",
            label: "Motivaci\u00f3n escolar",
          },
          {
            label: "Puntaje (PT)",
            var: "38",
            type: "number",
          },
          {
            type: "h3",
            label: "Autocontrol y autonomia",
          },
          {
            label: "Puntaje (PT)",
            var: "39",
            type: "number",
          },
          {
            type: "h3",
            label: "Conductas pro sociales",
          },
          {
            label: "Puntaje (PT)",
            var: "40",
            type: "number",
          },
          {
            type: "h3",
            label: "Autoconcepto y autoestima",
          },
          {
            label: "Puntaje (PT)",
            var: "41",
            type: "number",
          },
          { type: "h3", label: "Prueba de Índice cognitivo (IGC)" },
          { label: "Puntaje (PT)", var: "184", type: "number" },
          { type: "h3", label: "Prueba de Índice lectura (IGL)" },
          { label: "Puntaje (PT)", var: "185", type: "number" },
          { type: "h3", label: "Prueba de Índice escritura (IGE)" },
          { label: "Puntaje (PT)", var: "186", type: "number" },
          { type: "h3", label: "Prueba de Índice matemáticas (IGM)" },
          { label: "Puntaje (PT)", var: "187", type: "number" },
        ],
        [
          {
            type: "h3",
            label: "Prueba de Reflexividad (RE)",
          },
          {
            label: "Puntaje (PT)",
            var: "43",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de Analog\u00edas (PA)",
          },
          {
            label: "Puntaje (PT)",
            var: "44",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de Organizaci\u00f3n perceptiva (OP)",
          },
          {
            label: "Puntaje (PT)",
            var: "45",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de Memoria y atenci\u00f3n (MA)",
          },
          {
            label: "Puntaje (PT)",
            var: "42",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de Comprension lectora (CL)",
          },
          {
            label: "Puntaje (PT)",
            var: "46",
            type: "number",
          },
          {
            type: "h3",
            label: "Eficacia lectora (EF)",
          },
          {
            label: "Puntaje (PT)",
            var: "47",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de Ortograf\u00eda Visual (OR)",
          },
          {
            label: "Puntaje (PT)",
            var: "50",
            type: "number",
          },
          {
            type: "h3",
            label: "Expresion escrita (GF)",
          },
          {
            label: "Puntaje (PT)",
            var: "49",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de Ortografia fon\u00e9tica (OF)",
          },
          {
            label: "Puntaje (PT)",
            var: "48",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de C\u00e1lculo y numeraci\u00f3n (CN)",
          },
          {
            label: "Puntaje (PT)",
            var: "51",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de Resoluci\u00f3n de problemas (RP)",
          },
          {
            label: "Puntaje (PT)",
            var: "52",
            type: "number",
          },
          {
            type: "h3",
            label: "Motivaci\u00f3n escolar",
          },
          {
            label: "Puntaje (PT)",
            var: "53",
            type: "number",
          },
          {
            type: "h3",
            label: "Autocontrol y autonomia",
          },
          {
            label: "Puntaje (PT)",
            var: "54",
            type: "number",
          },
          {
            type: "h3",
            label: "Conductas pro sociales",
          },
          {
            label: "Puntaje (PT)",
            var: "55",
            type: "number",
          },
          {
            type: "h3",
            label: "Autoconcepto y autoestima",
          },
          {
            label: "Puntaje (PT)",
            var: "56",
            type: "number",
          },
          { type: "h3", label: "Prueba de Índice cognitivo (IGC)" },
          { label: "Puntaje (PT)", var: "188", type: "number" },
          { type: "h3", label: "Prueba de Índice lectura (IGL)" },
          { label: "Puntaje (PT)", var: "189", type: "number" },
          { type: "h3", label: "Prueba de Índice escritura (IGE)" },
          { label: "Puntaje (PT)", var: "190", type: "number" },
          { type: "h3", label: "Prueba de Índice matemáticas (IGM)" },
          { label: "Puntaje (PT)", var: "191", type: "number" },
        ],
        [
          {
            type: "h3",
            label: "Prueba de Reflexividad (RE)",
          },
          {
            label: "Puntaje (PT)",
            var: "58",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de Analog\u00edas (PA)",
          },
          {
            label: "Puntaje (PT)",
            var: "59",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de Organizaci\u00f3n perceptiva (OP)",
          },
          {
            label: "Puntaje (PT)",
            var: "60",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de Memoria y atenci\u00f3n (MA)",
          },
          {
            label: "Puntaje (PT)",
            var: "57",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de Comprension lectora (CL)",
          },
          {
            label: "Puntaje (PT)",
            var: "63",
            type: "number",
          },
          {
            type: "h3",
            label: "Eficacia lectora (EF)",
          },
          {
            label: "Puntaje (PT)",
            var: "64",
            type: "number",
          },
          /*{
            type: "h3",
            label: "Velocidad lectora (comprensi\u00f3n)",
          },
          {
            label: "Puntaje (PT)",
            var: "61",
            type: "number",
          },*/
          {
            type: "h3",
            label: "Velocidad lectora (palabras x minuto) (PPM)",
          },
          {
            label: "Puntaje (PT)",
            var: "62",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de Ortograf\u00eda Visual (OR)",
          },
          {
            label: "Puntaje (PT)",
            var: "65",
            type: "number",
          },
          {
            type: "h3",
            label: "Expresion escrita (GR)",
          },
          {
            label: "Puntaje (PT)",
            var: "67",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de Ortografia fon\u00e9tica (OF)",
          },
          {
            label: "Puntaje (PT)",
            var: "66",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de C\u00e1lculo y numeraci\u00f3n (CN)",
          },
          {
            label: "Puntaje (PT)",
            var: "68",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de Resoluci\u00f3n de problemas (RP)",
          },
          {
            label: "Puntaje (PT)",
            var: "69",
            type: "number",
          },
          {
            type: "h3",
            label: "Motivaci\u00f3n escolar",
          },
          {
            label: "Puntaje (PT)",
            var: "70",
            type: "number",
          },
          {
            type: "h3",
            label: "Autocontrol y autonomia",
          },
          {
            label: "Puntaje (PT)",
            var: "71",
            type: "number",
          },
          {
            type: "h3",
            label: "Conductas pro sociales",
          },
          {
            label: "Puntaje (PT)",
            var: "72",
            type: "number",
          },
          {
            type: "h3",
            label: "Autoconcepto y autoestima",
          },
          {
            label: "Puntaje (PT)",
            var: "73",
            type: "number",
          },
          { type: "h3", label: "Prueba de Índice cognitivo (IGC)" },
          { label: "Puntaje (PT)", var: "192", type: "number" },
          { type: "h3", label: "Prueba de Índice lectura (IGL)" },
          { label: "Puntaje (PT)", var: "193", type: "number" },
          { type: "h3", label: "Prueba de Índice escritura (IGE)" },
          { label: "Puntaje (PT)", var: "194", type: "number" },
          { type: "h3", label: "Prueba de Índice matemáticas (IGM)" },
          { label: "Puntaje (PT)", var: "195", type: "number" },
        ],
        [
          {
            type: "h3",
            label: "Prueba de Reflexividad (RE)",
          },
          {
            label: "Puntaje (PT)",
            var: "75",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de Analog\u00edas (PA)",
          },
          {
            label: "Puntaje (PT)",
            var: "76",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de Organizaci\u00f3n perceptiva (OP)",
          },
          {
            label: "Puntaje (PT)",
            var: "77",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de Memoria y atenci\u00f3n (MA)",
          },
          {
            label: "Puntaje (PT)",
            var: "74",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de Comprension lectora (CL)",
          },
          {
            label: "Puntaje (PT)",
            var: "78",
            type: "number",
          },
          {
            type: "h3",
            label: "Eficacia Lectora (EF)",
          },
          {
            label: "Puntaje (PT)",
            var: "79",
            type: "number",
          },
          /*{
            type: "h3",
            label: "Velocidad lectora (nivel de comprensi\u00f3n)",
          },
          {
            label: "Puntaje (PT)",
            var: "80",
            type: "number",
          },*/
          {
            type: "h3",
            label: "Velocidad lectora (palabras x minuto) (PPM)",
          },
          {
            label: "Puntaje (PT)",
            var: "81",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de Ortograf\u00eda Visual (OR)",
          },
          {
            label: "Puntaje (PT)",
            var: "83",
            type: "number",
          },
          {
            type: "h3",
            label: "Grafia y expresion escrita (GR)",
          },
          {
            label: "Puntaje (PT)",
            var: "84",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de Ortografia fon\u00e9tica (OF)",
          },
          {
            label: "Puntaje (PT)",
            var: "82",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de C\u00e1lculo y numeraci\u00f3n (CN)",
          },
          {
            label: "Puntaje (PT)",
            var: "85",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de Resoluci\u00f3n de problemas (RP)",
          },
          {
            label: "Puntaje (PT)",
            var: "86",
            type: "number",
          },
          {
            type: "h3",
            label: "Motivaci\u00f3n escolar",
          },
          {
            label: "Puntaje (PT)",
            var: "87",
            type: "number",
          },
          {
            type: "h3",
            label: "Autocontrol y autonomia",
          },
          {
            label: "Puntaje (PT)",
            var: "88",
            type: "number",
          },
          {
            type: "h3",
            label: "Conductas pro sociales",
          },
          {
            label: "Puntaje (PT)",
            var: "89",
            type: "number",
          },
          {
            type: "h3",
            label: "Autoconcepto y autoestima",
          },
          {
            label: "Puntaje (PT)",
            var: "90",
            type: "number",
          },
          { type: "h3", label: "Prueba de Índice cognitivo (IGC)" },
          { label: "Puntaje (PT)", var: "196", type: "number" },
          { type: "h3", label: "Prueba de Índice lectura (IGL)" },
          { label: "Puntaje (PT)", var: "197", type: "number" },
          { type: "h3", label: "Prueba de Índice escritura (IGE)" },
          { label: "Puntaje (PT)", var: "198", type: "number" },
          { type: "h3", label: "Prueba de Índice matemáticas (IGM)" },
          { label: "Puntaje (PT)", var: "199", type: "number" },
        ],
        [
          {
            type: "h3",
            label: "Prueba de Reflexividad (RE)",
          },
          {
            label: "Puntaje (PT)",
            var: "92",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de Analog\u00edas (PA)",
          },
          {
            label: "Puntaje (PT)",
            var: "93",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de Organizaci\u00f3n perceptiva (OP)",
          },
          {
            label: "Puntaje (PT)",
            var: "94",
            type: "number",
          },
          {
            type: "h3",
            label: "Memoria y atenci\u00f3n (MA)",
          },
          {
            label: "Puntaje (PT)",
            var: "91",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de Comprension lectora (CL)",
          },
          {
            label: "Puntaje (PT)",
            var: "96",
            type: "number",
          },
          {
            type: "h3",
            label: "Eficacia lectora (EF)",
          },
          {
            label: "Puntaje (PT)",
            var: "95",
            type: "number",
          },
          /*{
            type: "h3",
            label: "Velocidad lectora (Comprensi\u00f3n)",
          },
          {
            label: "Puntaje (PT)",
            var: "97",
            type: "number",
          },*/
          {
            type: "h3",
            label: "Velocidad lectora (Palabras x minuto) (PPM)",
          },
          {
            label: "Puntaje (PT)",
            var: "98",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de Ortograf\u00eda Visual (OR)",
          },
          {
            label: "Puntaje (PT)",
            var: "100",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de Expresi\u00f3n escrita (GR)",
          },
          {
            label: "Puntaje (PT)",
            var: "101",
            type: "number",
          },
          {
            type: "h3",
            label: "Ortografia fon\u00e9tica (OF)",
          },
          {
            label: "Puntaje (PT)",
            var: "99",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de C\u00e1lculo y numeraci\u00f3n (CN)",
          },
          {
            label: "Puntaje (PT)",
            var: "102",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de Resoluci\u00f3n de problemas (RP)",
          },
          {
            label: "Puntaje (PT)",
            var: "103",
            type: "number",
          },
          {
            type: "h3",
            label: "Motivaci\u00f3n escolar",
          },
          {
            label: "Puntaje (PT)",
            var: "104",
            type: "number",
          },
          {
            type: "h3",
            label: "Autocontrol y autonomia",
          },
          {
            label: "Puntaje (PT)",
            var: "105",
            type: "number",
          },
          {
            type: "h3",
            label: "Conductas pro sociales",
          },
          {
            label: "Puntaje (PT)",
            var: "106",
            type: "number",
          },
          {
            type: "h3",
            label: "Autoconcepto y autoestima",
          },
          {
            label: "Puntaje (PT)",
            var: "107",
            type: "number",
          },
          { type: "h3", label: "Prueba de Índice cognitivo (IGC)" },
          { label: "Puntaje (PT)", var: "200", type: "number" },
          { type: "h3", label: "Prueba de Índice lectura (IGL)" },
          { label: "Puntaje (PT)", var: "201", type: "number" },
          { type: "h3", label: "Prueba de Índice escritura (IGE)" },
          { label: "Puntaje (PT)", var: "202", type: "number" },
          { type: "h3", label: "Prueba de Índice matemáticas (IGM)" },
          { label: "Puntaje (PT)", var: "203", type: "number" },
        ],
        [
          {
            type: "h3",
            label: "Razonamiento inductivo (RI)",
          },
          {
            label: "Puntaje (PT)",
            var: "110",
            type: "number",
          },
          {
            type: "h3",
            label: "Razonamiento espacial (RS)",
          },
          {
            label: "Puntaje (PT)",
            var: "111",
            type: "number",
          },
          {
            type: "h3",
            label: "Razonamiento deductivo (RD)",
          },
          {
            label: "Puntaje (PT)",
            var: "109",
            type: "number",
          },
          {
            type: "h3",
            label: "Atencion concentracion (AT)",
          },
          {
            label: "Puntaje (PT)",
            var: "108",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de Comprension lectora (CL)",
          },
          {
            label: "Puntaje (PT)",
            var: "113",
            type: "number",
          },
          {
            type: "h3",
            label: "Eficacia lectora (EF)",
          },
          {
            label: "Puntaje (PT)",
            var: "112",
            type: "number",
          },
          /*{
            type: "h3",
            label: "Velocidad lectora (comprensi\u00f3n)",
          },
          {
            label: "Puntaje (PT)",
            var: "114",
            type: "number",
          },*/
          {
            type: "h3",
            label: "Velocidad lectora (Palabras x minuto) (PPM)",
          },
          {
            label: "Puntaje (PT)",
            var: "115",
            type: "number",
          },
          {
            type: "h3",
            label: "Expresion escrita (EE)",
          },
          {
            label: "Puntaje (PT)",
            var: "118",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de Ortografia fon\u00e9tica",
          },
          {
            label: "Puntaje (PT)",
            var: "116",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de Ortograf\u00eda Visual",
          },
          {
            label: "Puntaje (PT)",
            var: "117",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de C\u00e1lculo y numeraci\u00f3n (CN)",
          },
          {
            label: "Puntaje (PT)",
            var: "119",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de Resoluci\u00f3n de problemas (RP)",
          },
          {
            label: "Puntaje (PT)",
            var: "120",
            type: "number",
          },
          {
            type: "h3",
            label: "Estrategias de trabajo y estudio",
          },
          {
            label: "Puntaje (PT)",
            var: "121",
            type: "number",
          },
          {
            type: "h3",
            label: "Motivaci\u00f3n escolar",
          },
          {
            label: "Puntaje (PT)",
            var: "122",
            type: "number",
          },
          {
            type: "h3",
            label: "Autocontrol y autonomia",
          },
          {
            label: "Puntaje (PT)",
            var: "123",
            type: "number",
          },
          {
            type: "h3",
            label: "Conductas pro sociales",
          },
          {
            label: "Puntaje (PT)",
            var: "124",
            type: "number",
          },
          {
            type: "h3",
            label: "Autoconcepto y autoestima",
          },
          {
            label: "Puntaje (PT)",
            var: "125",
            type: "number",
          },
          { type: "h3", label: "Prueba de Índice cognitivo (IGC)" },
          { label: "Puntaje (PT)", var: "204", type: "number" },
          { type: "h3", label: "Prueba de Índice lectura (IGL)" },
          { label: "Puntaje (PT)", var: "205", type: "number" },
          { type: "h3", label: "Prueba de Índice escritura (IGE)" },
          { label: "Puntaje (PT)", var: "206", type: "number" },
          { type: "h3", label: "Prueba de Índice matemáticas (IGM)" },
          { label: "Puntaje (PT)", var: "207", type: "number" },
        ],
        [
          {
            type: "h3",
            label: "Razonamiento inductivo (RI)",
          },
          {
            label: "Puntaje (PT)",
            var: "127",
            type: "number",
          },
          {
            type: "h3",
            label: "Razonamiento espacial (RS)",
          },
          {
            label: "Puntaje (PT)",
            var: "128",
            type: "number",
          },
          {
            type: "h3",
            label: "Razonamiento deductivo (RD)",
          },
          {
            label: "Puntaje (PT)",
            var: "129",
            type: "number",
          },
          {
            type: "h3",
            label: "Atencion concentracion (AT)",
          },
          {
            label: "Puntaje (PT)",
            var: "126",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de Comprension lectora (CL)",
          },
          {
            label: "Puntaje (PT)",
            var: "131",
            type: "number",
          },
          {
            type: "h3",
            label: "Eficacia lectora (EF)",
          },
          {
            label: "Puntaje (PT)",
            var: "130",
            type: "number",
          },
          /*{
            type: "h3",
            label: "Velocidad lectora (comprensi\u00f3n)",
          },
          {
            label: "Puntaje (PT)",
            var: "132",
            type: "number",
          },*/
          {
            type: "h3",
            label: "Velocidad lectora (palabras x minuto) (PPM)",
          },
          {
            label: "Puntaje (PT)",
            var: "133",
            type: "number",
          },
          {
            type: "h3",
            label: "Expresion escrita (EE)",
          },
          {
            label: "Puntaje (PT)",
            var: "134",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de Ortograf\u00eda Visual (OR)",
          },
          {
            label: "Puntaje (PT)",
            var: "135",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de C\u00e1lculo y numeraci\u00f3n (CN)",
          },
          {
            label: "Puntaje (PT)",
            var: "136",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de Resoluci\u00f3n de problemas (RP)",
          },
          {
            label: "Puntaje (PT)",
            var: "137",
            type: "number",
          },
          {
            type: "h3",
            label: "Estrategias de trabajo y estudio",
          },
          {
            label: "Puntaje (PT)",
            var: "138",
            type: "number",
          },
          {
            type: "h3",
            label: "Adaptación Personal",
          },
          {
            label: "Puntaje (PT)",
            var: "139",
            type: "number",
          },
          {
            type: "h3",
            label: "Adaptación Familiar",
          },
          {
            label: "Puntaje (PT)",
            var: "140",
            type: "number",
          },
          {
            type: "h3",
            label: "Adaptación Escolar",
          },
          {
            label: "Puntaje (PT)",
            var: "141",
            type: "number",
          },
          {
            type: "h3",
            label: "Habilidades Sociales",
          },
          {
            label: "Puntaje (PT)",
            var: "142",
            type: "number",
          },
          { type: "h3", label: "Prueba de Índice cognitivo (IGC)" },
          { label: "Puntaje (PT)", var: "208", type: "number" },
          { type: "h3", label: "Prueba de Índice lectura (IGL)" },
          { label: "Puntaje (PT)", var: "209", type: "number" },
          { type: "h3", label: "Prueba de Índice escritura (IGE)" },
          { label: "Puntaje (PT)", var: "210", type: "number" },
          { type: "h3", label: "Prueba de Índice matemáticas (IGM)" },
          { label: "Puntaje (PT)", var: "211", type: "number" },
        ],
        [
          {
            type: "h3",
            label: "Razonamiento inductivo (RI)",
          },
          {
            label: "Puntaje (PT)",
            var: "144",
            type: "number",
          },
          {
            type: "h3",
            label: "Razonamiento espacial (RS)",
          },
          {
            label: "Puntaje (PT)",
            var: "145",
            type: "number",
          },
          {
            type: "h3",
            label: "Razonamiento deductivo (RD)",
          },
          {
            label: "Puntaje (PT)",
            var: "146",
            type: "number",
          },
          {
            type: "h3",
            label: "Atencion concentracion (AT)",
          },
          {
            label: "Puntaje (PT)",
            var: "143",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de Comprension lectora (CL)",
          },
          {
            label: "Puntaje (PT)",
            var: "147",
            type: "number",
          },
          {
            type: "h3",
            label: "Eficacia lectora (EF)",
          },
          {
            label: "Puntaje (PT)",
            var: "148",
            type: "number",
          },
          /*{
            type: "h3",
            label: "Velocidad lectora (nivel de comprensi\u00f3n)",
          },
          {
            label: "Puntaje (PT)",
            var: "149",
            type: "number",
          },*/
          {
            type: "h3",
            label: "Velocidad lectora (palabras x minuto) (PPM)",
          },
          {
            label: "Puntaje (PT)",
            var: "150",
            type: "number",
          },
          {
            type: "h3",
            label: "Expresion escrita (EE)",
          },
          {
            label: "Puntaje (PT)",
            var: "152",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de Ortograf\u00eda Visual (OR)",
          },
          {
            label: "Puntaje (PT)",
            var: "151",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de C\u00e1lculo y numeraci\u00f3n (CN)",
          },
          {
            label: "Puntaje (PT)",
            var: "153",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de Resoluci\u00f3n de problemas (RP)",
          },
          {
            label: "Puntaje (PT)",
            var: "154",
            type: "number",
          },
          {
            type: "h3",
            label: "Estrategias de trabajo y estudio",
          },
          {
            label: "Puntaje (PT)",
            var: "155",
            type: "number",
          },
          {
            type: "h3",
            label: "Adaptación Personal",
          },
          {
            label: "Puntaje (PT)",
            var: "156",
            type: "number",
          },
          {
            type: "h3",
            label: "Adaptación Familiar",
          },
          {
            label: "Puntaje (PT)",
            var: "157",
            type: "number",
          },
          {
            type: "h3",
            label: "Adaptación Escolar",
          },
          {
            label: "Puntaje (PT)",
            var: "158",
            type: "number",
          },
          {
            type: "h3",
            label: "Habilidades Sociales",
          },
          {
            label: "Puntaje (PT)",
            var: "159",
            type: "number",
          },
          { type: "h3", label: "Prueba de Índice cognitivo (IGC)" },
          { label: "Puntaje (PT)", var: "212", type: "number" },
          { type: "h3", label: "Prueba de Índice lectura (IGL)" },
          { label: "Puntaje (PT)", var: "213", type: "number" },
          { type: "h3", label: "Prueba de Índice escritura (IGE)" },
          { label: "Puntaje (PT)", var: "214", type: "number" },
          { type: "h3", label: "Prueba de Índice matemáticas (IGM)" },
          { label: "Puntaje (PT)", var: "215", type: "number" },
        ],
        [
          {
            type: "h3",
            label: "Razonamiento inductivo (RI)",
          },
          {
            label: "Puntaje (PT)",
            var: "161",
            type: "number",
          },
          {
            type: "h3",
            label: "Razonamiento espacial (RS)",
          },
          {
            label: "Puntaje (PT)",
            var: "162",
            type: "number",
          },
          {
            type: "h3",
            label: "Razonamiento deductivo (RD)",
          },
          {
            label: "Puntaje (PT)",
            var: "163",
            type: "number",
          },
          {
            type: "h3",
            label: "Atencion concentracion (AT)",
          },
          {
            label: "Puntaje (PT)",
            var: "160",
            type: "number",
          },
          /*{
            type: "h3",
            label: "Velocidad lectora (nivel de comprensi\u00f3n)",
          },
          {
            label: "Puntaje (PT)",
            var: "164",
            type: "number",
          },*/
          {
            type: "h3",
            label: "Prueba de Comprension lectora (CL)",
          },
          {
            label: "Puntaje (PT)",
            var: "166",
            type: "number",
          },
          {
            type: "h3",
            label: "Velocidad lectora (palabras x minuto) (PPM)",
          }, 
          {
            label: "Puntaje (PT)",
            var: "165",
            type: "number",
          },
          {
            type: "h3",
            label: "Expresion escrita (EE)",
          },
          {
            label: "Puntaje (PT)",
            var: "168",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de Ortograf\u00eda Visual (OR)",
          },
          {
            label: "Puntaje (PT)",
            var: "167",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de C\u00e1lculo y numeraci\u00f3n (CN)",
          },
          {
            label: "Puntaje (PT)",
            var: "169",
            type: "number",
          },
          {
            type: "h3",
            label: "Prueba de Resoluci\u00f3n de problemas (RP)",
          },
          {
            label: "Puntaje (PT)",
            var: "170",
            type: "number",
          },
          {
            type: "h3",
            label: "Estrategias de trabajo y estudio",
          },
          {
            label: "Puntaje (PT)",
            var: "171",
            type: "number",
          },
          {
            type: "h3",
            label: "Adaptación Personal",
          },
          {
            label: "Puntaje (PT)",
            var: "172",
            type: "number",
          },
          {
            type: "h3",
            label: "Adaptación Familiar",
          },
          {
            label: "Puntaje (PT)",
            var: "173",
            type: "number",
          },
          {
            type: "h3",
            label: "Adaptación Escolar",
          },
          {
            label: "Puntaje (PT)",
            var: "174",
            type: "number",
          },
          {
            type: "h3",
            label: "Habilidades Sociales",
          },
          {
            label: "Puntaje (PT)",
            var: "175",
            type: "number",
          },
          { type: "h3", label: "Prueba de Índice cognitivo (IGC)" },
          { label: "Puntaje (PT)", var: "216", type: "number" },
          { type: "h3", label: "Prueba de Índice lectura (IGL)" },
          { label: "Puntaje (PT)", var: "217", type: "number" },
          { type: "h3", label: "Prueba de Índice escritura (IGE)" },
          { label: "Puntaje (PT)", var: "218", type: "number" },
          { type: "h3", label: "Prueba de Índice matemáticas (IGM)" },
          { label: "Puntaje (PT)", var: "219", type: "number" },
        ],
      ],
    };
  },
};
</script>

<style lang=""></style>
:required_fields="required"
